<template>
  <div class="flex flex-col min-h-screen bg-[#e8e5de] font-nunito">
    <!-- Barre supérieure noire avec logo à droite -->
    <nav
      class="w-full flex items-center justify-end px-6 bg-black h-16 shadow-sm"
    >
      <img
        src="@/assets/nom_G.png"
        alt="Logo entreprise"
        class="h-5 w-auto object-contain"
      />
    </nav>

    <!-- Contenu login centré -->
    <div class="flex items-center justify-center flex-1">
      <div
        class="bg-white shadow-md rounded-lg p-8 w-full max-w-sm border border-[#ec4400]"
      >
        <h2 class="text-3xl font-bold mb-6 text-center text-[#ec4400]">
          Connexion
        </h2>

        <input
          v-model="username"
          type="text"
          placeholder="Nom d'utilisateur"
          class="w-full p-3 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-[#ec4400]"
        />

        <input
          v-model="password"
          type="password"
          placeholder="Mot de passe"
          class="w-full p-3 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-[#ec4400]"
        />

        <p v-if="authStore.error" class="text-red-600 text-sm mb-4 text-center">
          {{ authStore.error }}
        </p>

        <button
          @click="login"
          class="w-full bg-[#ec4400] hover:bg-[#b33300] text-white p-3 rounded font-semibold transition-colors duration-200"
        >
          Se connecter
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAuthStore } from './auth.store';

const authStore = useAuthStore();

const username = ref('');
const password = ref('');

async function login() {
  try {
    await authStore.login({ username: username.value, password: password.value });
    // authStore.login handles redirection on success
  } catch (e) {
    console.error('Login attempt failed in component:', e.message);
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Nunito&display=swap");

.font-nunito {
  font-family: "Nunito", sans-serif;
}
</style>